<template>
  <div class="preview">
    <figure class="image">
      <div class="thumb-wrap">
        <img v-if="galleryPreview && galleryPreview['sizes']" :src="galleryPreview['sizes']['gallery-thumb']">
        <div v-if="isVideo" class="play-icon-overlay">
          <div class="play-circle">
            <i class="fa fa-play"></i>
          </div>
        </div>
      </div>
      <figcaption class="caption" v-html="gallery.gallery_name"></figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  props: {
    gallery: Object
  },
  computed: {
    isVideo() {
      return this.gallery && (this.gallery.type === 'video' || this.gallery.type === 'embed')
    },
    galleryPreview() {
      if (this.gallery) {
        if (this.gallery.type === 'embed' || this.gallery.type === 'video') {
          // Check if thumbnail is an object (in case REST API returns an ID)
          if (this.gallery.thumbnail && typeof this.gallery.thumbnail === 'object') {
            return this.gallery.thumbnail
          }
        }
        if (this.gallery.images && this.gallery.images.length > 0) {
          return this.gallery.images[0]
        }
      }
      return null
    }
  }
}
</script>

<style scoped lang="scss">
.preview {
  position: relative;

  .image {
    img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    &:first-child {
      position: relative;
    }

    &:not(:first-child) {
      position: absolute;
      top: 0;
      left: 0;
    }

    &:nth-child(2) {
      top: 4px;
      left: 4px;
    }
  }

  .thumb-wrap {
    position: relative;
    display: block;
  }

  .play-icon-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    .play-circle {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: rgba(239, 97, 35, 0.75);
      /* #ef6123 translucent */
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #fff;
        font-size: 24px;
        margin-left: 5px;
        /* Offset to center the play triangle visually */
      }
    }
  }

  .caption {
    font-weight: bold;
    font-size: 1.1rem;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// GalleryThumb.vue?78e95bed